// Redirect-after-login allowlist. Only redirect to one of these prefixes,
// otherwise default to the auth admin home. Same pattern dash uses today.

const VALID_REDIRECT_PREFIXES = [
  'https://dash.redwoodoperations.com',
  'https://mapsly.redwoodoperations.com',
  'https://sms.redwoodoperations.com',
  'https://wiki.redwoodoperations.com',
  'https://scheduler.redwoodoperations.com',
  'https://offer.redwoodoperations.com',
  'https://cam.redwoodoperations.com',
  'https://crm.redwoodoperations.com',
  'https://ingest.redwoodoperations.com',
  'https://deals.redwoodoperations.com',
  'https://lease.redwoodoperations.com',
  'https://utils.redwoodoperations.com',
  'https://redzaps.redwoodoperations.com',
  'https://portfolio.redwoodoperations.com',
  'https://auth.redwoodoperations.com',
  'http://localhost:',
];

export function isValidRedirect(url: string | null | undefined): boolean {
  if (!url) return false;
  return VALID_REDIRECT_PREFIXES.some((p) => url.startsWith(p));
}

export function getRedirectFromQuery(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get('redirect');
}
